<template>
    <v-flex xs12>
        <canvas id="sex" height="400" style="width: 100%"></canvas>
    </v-flex>
</template>

<script>
    import Chart from 'chart.js'

    export default {
        name: 'sexCustomer',
        props: ['dataSex'],
        mounted () {
            let ctx = document.getElementById('sex').getContext('2d')

            new Chart(ctx, {
                type: 'doughnut',
                data: {
                    labels: ['Мужчины', 'Женщины'],
                    datasets: [
                        {
                            data: [
                                this.dataSex.man,
                                this.dataSex.woman
                            ],
                            backgroundColor: [
                                '#2B65F0',
                                '#D0021B',
                            ],
                        }
                    ]
                },
                options: {
                    responsive: true,
                    legend: {
                        position: 'left',
                    },
                    title: {
                        display: true,
                        text: `Общее количество зарегистрированных - ${this.dataSex.all}`
                    }
                }
            })
        }
    }
</script>
